import { Component } from '@angular/core';

@Component({
    selector: 'app-commission-plan-rule-sales-team-create',
    templateUrl: './commission-plan-rule-sales-person-create.component.html',
    styleUrls: ['./commission-plan-rule-sales-person-create.component.scss'],
    standalone: false
})
export class CommissionPlanRuleSalesPersonCreateComponent {}
